import { Component, Input } from '@angular/core';
import { CryptoUtil } from "@qid/crypto";
import { EncryptionKeys } from '../../model/encryption-keys.model';
import { EncryptionKeysService } from '../../services/encryption-keys.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent } from '@qid/super';

@Component({
    selector: 'oneqid-nx-unlock-encryption-keys',
    templateUrl: './unlock-encryption-keys.component.html',
    styleUrl: './unlock-encryption-keys.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SexyModule,
        SuperButtonComponent,
    ],
})
export class UnlockEncryptionKeysComponent {

    @Input() encryptionKeys: EncryptionKeys = null;
    passwordInput: string;

    constructor(private encryptionKeysService: EncryptionKeysService) {
    }

    unlock = async () => {
        try {

        } catch (e) {
        }
    }
}
